// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "lba-log-reader{display:block;height:100%}.log-reader-container{position:relative;padding-top:92px;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.log-reader-form{background-color:#eee;position:absolute;top:0;width:100%}.log-reader-content{overflow-y:scroll;overflow-x:auto;width:100%;height:100%;padding:20px;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:serif}", ""]);
// Exports
module.exports = exports;
